const error = {
  title: 'Die angeforderte Seite konnte nicht gefunden werden.',
  subtitle: 'Überprüfen Sie, ob die Adresse bzw. URL falsch geschrieben wurde oder gehen Sie zurück zu:',
  button: {
    1: 'Startseite',
    2: 'Produktsuche',
    3: '(E-)Rezept hochladen',
    4: 'Login',
  },
}

export default error
